import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { DateRangeColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { getAllTrackerNumbers } from "sources/admin";

class PreservedTrackerLogs extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "Трекер",
                accessor: "trackerId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getAllTrackerNumbers,
                            inputProps: { name: "trackerId" },
                            propName: "deviceNumber",
                        }}
                    />
                ),
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Дата начала координат",
                accessor: "fromTime",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Координаты начала",
                accessor: "fromCoordinate",
                filterable: false,
                sortable: false,
                Cell: ({ value }) => value.join(", "),
            },
            {
                Header: "Дата окончания координат",
                accessor: "toTime",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Координаты окончания",
                accessor: "toCoordinate",
                filterable: false,
                sortable: false,
                Cell: ({ value }) => value.join(", "),
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className={"page-book__list book-list list"}>
                        {this.renderHead()}
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(PreservedTrackerLogs, "preserved-tracker-logs");
